<template>
  <div class="venueAppointment-topbar">
    <div class="venueAppointment-list-topbar">
      <div class="venueAppointment-search">
        <search :placeholder="venueNamePlaceholder" @search="venueNameSearch" />
      </div>
      <div class="venueAppointment-info-button-container">
        <button class="button add-venueAppointment" @click="addvenueAppointmentDialogShow"
          v-hasPermi="'sc:venueappointment:add'">
          <i class="iconfont icon-add"></i>新增预约
        </button>
        <!-- 批量删除 -->
        <button class="button delete-venueAppointment" @click="deleteClick" v-hasPermi="'sc:venueappointment:delete'">
          <i class="iconfont icon-delete" />批量删除
        </button>
      </div>
    </div>
    <div class="topbar-tabs">
      <div class="tab-item" :class="currentCourseItem == index ? 'current-item' : ''"
        v-for="(item, index) in statusList" :key="index" @click="changeCurrentTabItem(index)">
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";

export default {
  components: {
    search,
  },
  data() {
    return {
      currentCourseItem: 0,
      venueNamePlaceholder: "请输入场馆名称",
    };
  },
  props: {
    statusList: {
      type: Array,
      require: true,
    },
    deleteList: {
      type: Array,
    },
  },
  created() {
    // console.log(this.statusList);
  },
  methods: {
    // 切换状态
    changeCurrentTabItem(tabsIndex) {
      // console.log(tabsIndex);
      this.currentCourseItem = tabsIndex;
      // console.log(this.currentCourseItem);
      // 下标传值
      this.$emit("currentContentIndex", this.currentCourseItem);
    },
    venueNameSearch(e) {
      this.$emit("searchVenueName", e);
    },
    addvenueAppointmentDialogShow() {
      this.$emit("isAddvenueAppointmentShowSwitch", true);
    },
    // 批量删除
    deleteClick() {
      if (!this.deleteList.length) {
        return this.$message.warning("请先选择需要删除的预约信息");
      }
      this.$confirm("是否删除选中的预约信息?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除接口
          this.delete(this.$url.delVenueappointment + "/" + this.deleteList)
            .then((res) => {
              // console.log(res);
              if (res.code !== 200) return this.$message.error(res.msg);
              if (res.code == 200) {
                this.$message.success("删除成功");
              }
              this.$emit("delete", this.deleteList);
            })
            .catch((err) => {
              this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./venueAppointment-topbar.scss";
</style>
